/**
 * Created by Lenovo on 2017/5/24.
 */
let flag = '';
const _language = navigator.languages;
const currentLang = _language==undefined?navigator.language:_language[1];
if(currentLang == 'zh'){
    flag = 'zh';
}
else {
    flag = 'en';
}
const languages =
    {
        email: flag == 'zh'?'邮箱':'email',
        password: flag == 'zh'?'初始密码':'password',
        PermissionManagement: flag == 'zh'?'权限管理':'Permission Management',
        Subsystem: flag == 'zh'?'子系统':'Subsystem',
        SubsystemList: flag == 'zh'?'子系统列表':'Subsystem List',
        AddSubsystem:flag == 'zh'?'添加子系统':'Add Subsystem',
        EditSubsystem:flag == 'zh'?'编辑子系统':'Edit Subsystem',
        DetailSubsystem:flag == 'zh'?'查看子系统详情':'Detail Subsystem',
        SubsystemName:flag == 'zh'?'子系统名称':'Subsystem Name',
        SubsystemNumber:flag == 'zh'?'子系统编号':'Subsystem Number',
        AccessPath:flag == 'zh'?'访问路径':'Access Path',
        userTypeName :flag == 'zh'? '用户类型名称': 'userType Name',
        userType:flag == 'zh'?'用户类型':'userType',
        extendedCoding : flag == 'zh'?'扩展属性编码': 'extended Attribute Coding',
        extended:flag == 'zh'?'扩展属性':'extended',
        extendedName :flag == 'zh'?'扩展属性名称':'extended Attribute Name',
        defaultAttributeValue:flag == 'zh'?'默认属性值':'default Attribute Value',
        sendTime : flag == 'zh'?'发送时间': 'Send time',
        systemType : flag == 'zh'?'系统类型': 'System type',
        systemName : flag == 'zh'?'系统名称': 'System Name',
        versionNumber:flag == 'zh'?'版本号':'version Number',
        versionTime : flag == 'zh'?'版本时间': 'version time',
        download : flag == 'zh'?'下载地址': 'download',
        StatisticalManagement:flag == 'zh'?'统计管理':'Statistical Management',
        UserDistributionStatistics:flag == 'zh'?'用户分布统计':'User Distribution Statistics',
        UserInformationStatistics:flag == 'zh'?'用户信息统计':'User Information Statistics',
        StatisticsTime:flag == 'zh'?'统计时间':'Statistics Time',
        CreatePermissions:flag == 'zh'?'创建权限':'Create Permissions',
        CreateModel:flag == 'zh'?'创建模型':'Create Model',
        level:flag == 'zh'?'级别':'level',
        subsystem:flag == 'zh'?'所属子系统':'subsystem',
        proAdd :flag == 'zh'? '添加协议定义': 'protocol Add',
        proEdit:flag == 'zh'?'编辑协议定义':'protocol Edit',
        proName : flag == 'zh'?'协议名称': 'protocol Name',
        ModelCategory : flag == 'zh'?'模型类别': 'Model category',
        proHead : flag == 'zh'?'协议头' : 'protoco Head',
        proFoot : flag == 'zh'?'协议尾': 'protoco Foot',
        proCheckName:flag == 'zh'?'协议校验方式':'protoco Check Name',
        proCheckStart:flag == 'zh'?'协议校验开始位':'protoco Check Start',
        proCheckEnd:flag == 'zh'?'协议校验结束位':'protoco Check End',
        proDefinition:flag == 'zh'?'协议定义':'Protocol definition',
        proDefinitionList:flag == 'zh'?'协议定义列表':'Protocol definition',
        CategoryName : flag == 'zh'?'类别名称': 'Category Name',
        codePre:flag == 'zh'?'前缀':'codePre',
        pframework:flag == 'zh'?'所属协议':'pframework',
        meta:flag == 'zh'?'所属模块':'meta',
        paramCode:flag == 'zh'?'参数指令':'paramCode',
        paramName:flag == 'zh'?'参数中文名称':'paramName',
        paramNameEn :flag == 'zh'? '参数英文名称': 'paramNameEn',
        andvalue:flag == 'zh'?'与运算值':'andvalue',
        targetMeta : flag == 'zh'?'结果赋值模块': 'targetMeta',
        anCode:flag == 'zh'?'命令编码':'anCode',
        anName :flag == 'zh'?'命令名称':'anName',
        anValue :flag == 'zh'?'命令值':'anValue',
        metaNames:flag == 'zh'?'匹配模块':'metaNames',
        isSaveHis:flag == 'zh'?'转存历史':'isSaveHis',
        hisMsgType:flag == 'zh'?'消息类型':'hisMsgType',
        ProtocolParameter:flag == 'zh'?'协议参数':'Protocol Parameter',
        ProtocolParameterList:flag == 'zh'?'协议参数列表':'Protocol Parameter List',
        ProtocolParameterAdd:flag == 'zh'?'添加协议参数':'ProtocolParameter Add',
        ProtocolParameterEdit:flag == 'zh'?'编辑协议参数':'ProtocolParameter Edit',
        deviceManagement:flag == 'zh'?'设备管理':'device Management',
        DeviceOnlineInquiry:flag == 'zh'?'设备在线查询':'Device Online Inquiry',
        queryCriteria:flag == 'zh'?'查询条件':'query Criteria',
        organizationStructure:flag == 'zh'?'组织结构':'organization Structure',
        CreateOrganizationalStructures:flag == 'zh'?'创建组织结构':'Create Organizational Structures',
        TermOfValidity:flag == 'zh'?'有效期':'Term of validity',
        BasicConfiguration:flag == 'zh'?'基础配置':'Basic Configuration',
        Yes:flag == 'zh'?'是':'Yes',
        No:flag == 'zh'?'否':'No',
        CommandAnalysis:flag == 'zh'?'命令解析':'Command Analysis',
        CommandAnalysisList:flag == 'zh'?'命令解析列表':'Command Analysis List',
        CommandAnalysisAdd:flag == 'zh'?'添加命令解析':'Command Analysis Add',
        CommandAnalysisEdit:flag == 'zh'?'编辑命令解析':'Command Analysis Edit',
        ModelCreation:flag == 'zh'?'模型创建':'Model Creation',
        ModelCategoryList:flag == 'zh'?'模型类别列表':'Model Category List',
        ModelCategoryAdd:flag == 'zh'?'添加模型类别':'Model Category Add',
        ModelCategoryEdit:flag == 'zh'?'编辑模型类别':'Model Category Edit',
        APPManagement:flag == 'zh'?'APP管理':'APP Management',
        APPVersionsList:flag == 'zh'?'APP版本列表':'APP Versions List',
        APPVersionsAdd:flag == 'zh'?'添加APP版本':'APP Versions Add',
        APPVersionsEdit:flag == 'zh'?'编辑APP版本':'APPVer sions Edit',
        managers:flag == 'zh'?'管理员':'managers',
        managersList:flag == 'zh'?'管理员列表':'managers List',
        managersAdd:flag == 'zh'?'添加管理员':'managers Add',
        managersEdit:flag == 'zh'?'编辑管理员':'managers Edit',
        managersDetail:flag == 'zh'?'查看管理员信息':'managers Detail',
        userTypeList : flag == 'zh'?'用户类型列表': 'user Type List',
        userTypeAdd : flag == 'zh'?'添加用户类型': 'userType Add',
        userTypeEdit : flag == 'zh'?'编辑用户类型': 'userType Edit',
        extendedList:flag == 'zh'?'扩展属性列表':'extended List',
        IncompleteInformation:flag == 'zh'?'信息未填写！':'Incomplete Information！',
        AuthorityAssignment:flag == 'zh'?'权限分配':'Authority Assignment',
        fullName:flag == 'zh'?'姓名':'full Name',
        role:flag == 'zh'?'角色':'role',
        oldPass:flag == 'zh'?'原密码':'old password',
        newPass:flag == 'zh'?'新密码':'new password',
        passAgain:flag == 'zh'?'再次输入新密码':'password again',
        pleaseSelect:flag == 'zh'?'请选择':'please select',
        time:flag == 'zh'?"时间": "time",
        searchCondition:flag == 'zh'? "搜索条件": "Search Condition",
        configuration: flag == 'zh'?"配置": "Configuration",
        info: flag == 'zh'?"信息": "Information",
        query:flag == 'zh'? "查询": "Query",
        view:flag == 'zh'? "查看":'view',
        add: flag == 'zh'?"添加":'add',
        edit: flag == 'zh'?"编辑":'edit',
        delete:flag == 'zh'? "删除": "Delete",
        readyDelete:flag == 'zh'?'确定删除？': 'Are You Ready To Delete?',
        deleteNode:flag == 'zh'?'确定删除节点': 'Are you sure you want to delete nodes',
        remark: flag == 'zh'?"备注": "Remark",
        operation:flag == 'zh'? "操作": "Operation",
        background: flag == 'zh'?"后台": "Background",
        manage:flag == 'zh'? "管理": "Manage",
        apply: flag == 'zh'?"申请": "Apply",
        submit:flag == 'zh'? "提交": "Submit",
        return: flag == 'zh'?"返回": "Return",
        success:flag == 'zh'? "成功": "Success",
        failure: flag == 'zh'?"失败": "Failure",
        save:flag == 'zh'? "保存": "Save",
        unit: flag == 'zh'?"元": "dollar",
        detail: flag == 'zh'?"详情": "Detail",
        more: flag == 'zh'?"更多":'more',
        contacts:flag == 'zh'? "联系人": "contacts",
        name: flag == 'zh'?"名称": "Name",
        telephone: flag == 'zh'?"电话": "Telephone",
        contactTelephone: flag == 'zh'?"联系电话":'contact Telephone',
        createTime: flag == 'zh'?"创建时间": "Create Time",
        status: flag == 'zh'?"状态": "Status",
        address:flag == 'zh'?"地址": "Address",
        addressDetail:flag == 'zh'?"详细地址":"AddressDetail",
        disable:flag == 'zh'?"禁用": "disable",
        stop:flag == 'zh'?'停用':'stop',
        readyStop:flag == 'zh'?"确定停用?":"Are You Ready To Stop?",
        readyDisable:flag == 'zh'?"确定禁用?": "Are You Ready To Disable?",
        readyEnable:flag == 'zh'?"确定启用?": "Are You Ready To Enable?",
        readyFreeze:flag == 'zh'?"确定冻结账户?": "Are You Ready To Freeze?",
        readyUnfreeze:flag == 'zh'?"确定解冻账户?": "Are You Ready To Unfreeze?",
        enable:flag == 'zh'?"启用":'enable',
        freeze:flag == 'zh'?"冻结":'freeze',
        unfreeze:flag == 'zh'?"解冻":'unfreeze',
        noDataText:flag == 'zh'?"没找到数据": 'There is no data to display',
        no:flag == 'zh'?"编号": "No",
        IDCardNo:flag == 'zh'?"身份证号": "IDCardNo",
        invitationCode:flag == 'zh'?"邀请码": "Invitation Code",
        close:flag == 'zh'?"关闭": "Close",
        sure:flag == 'zh'?"确定": "Sure",
        export:flag == 'zh'?"导出": "Export",
        firstPage:flag == 'zh'?'首页': 'firstPage',
        lastPage:flag == 'zh'?'尾页': 'lastPage',
        valid:flag == 'zh'?'有效': 'valid',
        invalid:flag == 'zh'?'无效': 'invalid',
        prompt:flag == 'zh'?'提示':'prompt',
        recovery:flag == 'zh'?"恢复":"recovery",
        resetting:flag == 'zh'?"重置":'resetting',
        resetPassword:flag == 'zh'?"重置密码":'ResetPassword',
        loginName:flag == 'zh'?"登录账号":'LoginName',
        systemConfirm:flag == 'zh'?"系统确认":"System Confirm",
        AreYouSureDoThis:flag == 'zh'?"确定执行此操作吗?":"Are you sure do this?",
        roleManagement:flag == 'zh'?'角色管理': 'Role Management',
        roleList:flag == 'zh'?'角色列表': 'role list',
        roleName:flag == 'zh'?'角色名称': 'role name',
        roleNo:flag == 'zh'?'角色编号':'Role Number',
        addRole:flag == 'zh'?'添加角色': 'add role',
        editRole:flag == 'zh'?'编辑角色': 'edit role',
        userManage:flag == 'zh'?"用户管理": "User Manage",
        userList:flag == 'zh'?"用户列表": "User List",
        normalUser:flag == 'zh'?"普通用户": "NormalUser",
        normalUserList:flag == 'zh'?"APP用户列表": "NormalUser List",
        normalUserAdd:flag == 'zh'?"添加普通用户":"normalUser Add",
        normalUserEdit:flag == 'zh'?"编辑普通用户":"normalUser Edit",
        normalUserDetail:flag == 'zh'?"普通用户信息查看":"normalUser Detail",
        userDetail:flag == 'zh'?"查看用户详情": "User Detail",
        user:flag == 'zh'?"用户": "User",
        userAccount:flag == 'zh'?"用户账户":'user Account',
        realName:flag == 'zh'?'真实姓名':'realName',
        parentId:flag == 'zh'?'父类ID':'parentId',
        code:flag == 'zh'?'编码':'code',
        value:flag == 'zh'?'值':'value',
        byteNum:flag == 'zh'?'协议字节数':'byte Number',
        accuracy:flag =='zh'?'精度':'accuracy',
        deviationVal:flag=='zh'?'偏移量':'deviationVal',
        format:flag == 'zh'?'数据格式':'format',
        linkSign:flag == 'zh'?'连接符':'linkSign',
        hexConvert:flag == 'zh'?'进制换算':'hexConvert',
        isEntity:flag == 'zh'?'是否为实体属性':'isEntity',
        metaUnit:flag == 'zh'?'单位':'metaUnit',
        ID:'ID',
        registerTime:flag == 'zh'?'注册时间':'registerTime',
        selectRole:flag == 'zh'?'选择角色':'select role',
        TextQuery:flag == 'zh'?'短信查询':'Text Query',
        TextQueryList:flag == 'zh'?'短信查询列表':'Text Query List',
        MessageContent:flag == 'zh'?'短信内容':'Message Content',
        formType:flag == 'zh'?'表单类型':'form type',
        login :flag == 'zh'?'登录':'login',
        nodeNotEmpty:flag == 'zh'?'节点名称不能为空':'The node name cannot be empty',
        isMenu:flag == 'zh'?'是否为菜单':'isMenu',
        AccessNumber:flag == 'zh'?'权限编号':'Permission number',
        PermissionName:flag == 'zh'?'权限名称':'Permission Name',
        enName:flag == 'zh'?'英文名称':'enName',
        SchemaName: flag =='zh'?'架构名称':'Architecture name ',
        shortName:flag == 'zh'?'中文简称':'shortName',
        ArchitectureNumber:flag=='zh'?'架构编号':'Architecture number',
        abbreviation:flag=='zh'?'英文简称':'abbreviation',
        OTAManagement:flag == 'zh'?'OTA管理':'OTAManagement',
        OTAList:flag=='zh'?'OTA列表':'OTAList',
        OTAAdd:flag == 'zh'?'新增OTA配置':'OTA Add',
        versionName:flag == 'zh'?'版本名称':'version name',
        openID:flag == 'zh'?'厂商ID':'openID',
        productID:flag == 'zh'?'产品ID':'productID',
        deviceID:flag == 'zh'?'设备ID':'deviceID',
        deviceNo: flag == 'zh'?'设备编号':'deviceNo',
        dvcModel :flag == 'zh'?'型号':'dvcModel ',
        SoftwareType :flag == 'zh'?'软件类型':'Software Type',
        firmwareUpload:flag == 'zh'?'固件上传':'firmware upload',
        AirPurifierManagement:flag =='zh'?'空净管理':'Air purifier management',
        AirPurifierSearch:flag == 'zh'?'空净查询':'Air purifier search',
        AirPurifierList:flag == 'zh'?'空净列表':'Air purifier list',
        ConnectionStatus:flag == 'zh'?'连接状态':'Connection status',
        SearchBindList:flag == 'zh'?'设备绑定列表':'Search Bind List',
        userId:flag == 'zh'?'用户ID':'userId',
        unBind:flag == 'zh'?'解绑':'unBind',
        unBindDevice : flag == 'zh'?'解绑设备':'unBindDevice',
        ReayToUnBindDevice : flag == 'zh'?'确定解绑？':'Reay To UnBind Device?',
        businessList: flag == 'zh'?'商户列表':'business List',
        businessCode: flag == 'zh'?'商户编号':'business Code',
        loginAccount: flag == 'zh'?'登录账户':'login Account',
        deviceList:flag == 'zh'?'设备列表':'device List',
        businessAdd: flag == 'zh'?'添加商户':'business Add',
        businessEidt: flag == 'zh'?'编辑商户':'business Edit',
        businessDetail: flag == 'zh'?'详情商户信息':'business Detail',
        businessName: flag == 'zh'?'商户名称':'business Name',
        region: flag == 'zh'?'地区':'region',
        APPAccount: flag == 'zh'?'APP登录账户':'APP Account',
        APPPassword: flag == 'zh'?'APP登录密码':'Password',
        initBtn: flag == 'zh'?'设备初始化':'init Button',
        ReayToinitBtn: flag == 'zh'?'确认设备初始化？':'Reay To Init Device?',
        Update: flag == 'zh'?'更新设备':'',
        readyUpdate: flag == 'zh'?'确定更新？':'',
        appType: flag == 'zh'?'APP类型？':'APP Type',
    }
export default languages;


// WEBPACK FOOTER //
// ./modules/utils/language.js